export const isNativeMobileApp = () => Boolean(window.App);
